/**
 * @file JobHeaderExtraInfoSlot.tsx
 *
 * @fileoverview Renders the original job ad modal.
 */

import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import React, { useState } from 'react';
import Modal from '~/vcl/atoms/15-modal';
import { Button } from '~/vcl/atoms/01-forms/01-button';

interface JobHeaderExtraInfoSlotProps {
  /**
   * The job entity.
   */
  job: Slottable<any>;
}

export default function JobHeaderExtraInfoSlot({
  job,
}: JobHeaderExtraInfoSlotProps) {
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
  const pdfExtensions = ['pdf'];

  const [showModal, setModalIsOpen] = useState(false);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const handleClose = () => {
    setModalIsOpen(false);
  };

  const getFileType = (url) => {
    if (!url) {
      return null;
    }
    const extension = url.split('.').pop().toLowerCase();
    if (pdfExtensions.includes(extension)) {
      return 'pdf';
    }
    if (imageExtensions.includes(extension)) {
      return 'image';
    }
    return null;
  };

  const jobSourceLink = job.jobSourceLink;
  const fileType = getFileType(jobSourceLink);

  return (
    jobSourceLink &&
    fileType && (
      <>
        <Button title="View Ad" buttonStyle="secondary" onClick={openModal}>
          View Ad
        </Button>
        {showModal && (
          <Modal
            id="job_source_link_modal"
            showClose={true}
            closeTitle="Close"
            isShown={showModal}
            onHide={handleClose}
            maxWidth="550px"
            padding={[0, 11]}
          >
            {fileType === 'image' && (
              <img src={jobSourceLink} alt="Original job source" />
            )}
            {fileType === 'pdf' && (
              <object
                data={jobSourceLink}
                type="application/pdf"
                width="100%"
                height="500px"
              >
                <embed src={jobSourceLink} type="application/pdf" />
              </object>
            )}
          </Modal>
        )}
      </>
    )
  );
}
export { JobHeaderExtraInfoSlot };
